export default function SectionBox(props: any) {
  return (
    <div className="my-5 py-5">
      <div className="text-center w-full mx-auto">
        {props.children}
      </div>
    </div>
  );
}
